import React, { useEffect, useState } from 'react';
import {Col, Dropdown, DropdownButton, FormCheck, Row} from 'react-bootstrap';
import {service as ActivityFeedFilterService} from "../../../Services/ActivityFeedFilterService";
import {service as ActivityFeedSubscriptionService} from "../../../Services/ActivityFeedSubscriptionService";
import {Glyphicon} from "../GlyphIcon";

export const ActivityFeedSubscriptionDropDown = ({ ContextNodeId }) => {
    const [filters, setFilters] = useState([]);
    const [subscriptions, setSubscriptions] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const [filterData, subscriptionData] = await Promise.all([
            ActivityFeedFilterService.Get(),
                ActivityFeedSubscriptionService.GetActivityFeedSubscriptionsForContextNodeId(ContextNodeId)
            ]);
            setFilters(filterData.result);
            setSubscriptions(subscriptionData.result);
        };
        fetchData();
    }, [ContextNodeId]);

    const deleteSubscription = async (id) => {
        await ActivityFeedSubscriptionService.DeleteActivityFeedSubscription(id);
        const subscriptionData = await ActivityFeedSubscriptionService.GetActivityFeedSubscriptionsForContextNodeId(ContextNodeId);
        setSubscriptions(subscriptionData.result);
    };

    const createSubscription = async (activityFeedFilterId) => {
        await ActivityFeedSubscriptionService.CreateActivityFeedSubscription(ContextNodeId, activityFeedFilterId);
        const subscriptionData = await ActivityFeedSubscriptionService.GetActivityFeedSubscriptionsForContextNodeId(ContextNodeId);
        setSubscriptions(subscriptionData.result);
    };
    
    const onItemSelect = (activityFeedFilterId) => {
        const filter = subscriptions.find(x => String(x.activityFeedFilterId) === String(activityFeedFilterId));
        if (filter) {
            void deleteSubscription(filter.activityFeedSubscriptionId);
        } else {
            void createSubscription(activityFeedFilterId);
        }
    };
    
    const getCheckbox = (activityFeedFilterId, checkBoxLabel) => {
        const filter = subscriptions.find(x => String(x.activityFeedFilterId) === String(activityFeedFilterId));

        return (
            <FormCheck
                id={activityFeedFilterId}
                checked={!!filter}
                label={checkBoxLabel}
            />
        );
    };

    return (
        <DropdownButton
            id="ActivityFeedSubscriptionDropDown"
            // autoClose="outside" /* only supported in v5 */
            variant={subscriptions.length ? "primary" : "default"}
            size="sm"
            align="end"
            title={<span><Glyphicon glyph="plus" /> {subscriptions.length ? "Subscribed" : "Subscribe"}</span>}
            className="sb-activity-feed-subscription-dropdown"
        >
            {filters.map(x => (
                <Dropdown.Item
                    key={x.activityFeedFilterId}
                    eventKey={x.activityFeedFilterId}
                    onSelect={onItemSelect}
                    className="sb-activity-feed-subscription-dropdown-row"
                    rootCloseEvent='click'
                >
                    <FormCheck
                        id={x.activityFeedFilterId}
                        checked={!!subscriptions.some(y => String(y.activityFeedFilterId) === String(x.activityFeedFilterId))}
                        label={x.name}
                    />
                </Dropdown.Item>
            ))}
            {/* This is broken currently so I'm hiding it. */}
            {/*<Dropdown.Divider key="divider" />*/}
            {/*<Dropdown.Item key="all" className="sb-activity-feed-subscription-dropdown-row">*/}
            {/*    <FormCheck*/}
            {/*        id={x.activityFeedFilterId}*/}
            {/*        checked={isAllChecked}*/}
            {/*        label={"Subscribe All"}*/}
            {/*    />*/}
            {/*    {getCheckbox(null, 'Subscribe All')}*/}
            {/*</Dropdown.Item>*/}
        </DropdownButton>
    );
};
